// extracted by mini-css-extract-plugin
module.exports = {"collection-container":"Purchases_collection-container__89T_u","input-container":"Purchases_input-container__W4TUT"};